import { FULL_DATE_HOURS_MINUTES } from '@/constants/dateFormat';
import dayjs from 'dayjs';
import * as Yup from 'yup';

/**
 * 租赁物品item
 */
export interface LeaseItemInfo {
  /**
   * 物品id
   */
  item_type: number;
  /**
   * 物品数量
   */
  item_amount: string;
}

/**
 * 租赁服务
 */
export interface LeaseInfo {
  /**
   * 服务id(编辑的时候传)
   */
  id?: string;
  /**
   * 会员id
   */
  member_id?: string;
  /**
   * 非会员id
   */
  not_member_id?: string;
  /**
   * 备注
   */
  remark?: string;
  /**
   * 租赁开始时间
   */
  start_date: string;
  /**
   * 租赁结束时间(编辑才有)
   */
  end_date?: string;
  /**
   * 质押方式
   */
  pledge_type: number;
  /**
   * 质押金额
   */
  pledge_price?: string;
  /**
   * pos小票编号
   */
  pos_no?: string;
  /**
   * 本次服务是否预约 0否 1是 编辑才有
   */
  is_subscribe?: number;
  /**
   * 当is_subscribe=1,传服务站点
   */
  servicesite_id?: number;
  /**
   * 预约日期
   */
  subscribe_date?: string;
  /**
   * 预约方式
   */
  subscribe_style?: string;
  /**
   * 预约备注
   */
  subscribe_remark?: string;
  /**
   * 是否归还物品 1否 2是
   */
  lease_status?: number;
  /**
   * 提交时转json字符串 里面包含以下数据,如果是修改里面要加id字段,如果删除的数据不要传给后台
   */
  lease_items: LeaseItemInfo[];
}

/**
 * 租赁服务表单默认值
 */
export const defaultLeaseInfo: LeaseInfo = {
  remark: '',
  start_date: dayjs(new Date()).format(FULL_DATE_HOURS_MINUTES),
  pledge_type: null,
  pledge_price: '',
  pos_no: '',
  lease_items: [
    {
      item_type: null,
      item_amount: '1',
    }],
};

/**
 * 租赁服务编辑表单默认值
 */
export const defaultLeaseEditInfo: LeaseInfo = {
  remark: '',
  start_date: '',
  end_date: '',
  pledge_type: null,
  pledge_price: '',
  pos_no: '',
  is_subscribe: null,
  servicesite_id: null,
  subscribe_date: '',
  subscribe_style: '',
  subscribe_remark: '',
  lease_status: null,
  lease_items: [
    {
      item_type: null,
      item_amount: '1',
    }],
};

/**
 * 租赁表单校验
 */
export const leaseSchema = Yup.object({
  start_date: Yup.string().ensure().required('请选择租赁开始时间'),
  pledge_type: Yup.number().typeError('请选择质押方式').required('请选择质押方式'),
  // pledge_price: Yup.string().required('请输入质押金额')
  //   .matches(/^(\d|[1-9]\d\d{0,3})$/, '请输入0-99999的整数金额'),
  lease_items: Yup.array()
    .of(
      Yup.object({
        item_type: Yup.number().typeError('请选择租赁物品').required('请选择租赁物品'),
        item_amount: Yup.string().ensure().required('请输入物品数量').matches(/^([1-9]|[1-9]\d|100)$/, '请输入1-100的正确数量'),
      })
    )
    .min(1, '请输入租赁物品信息')
    .required('请输入租赁物品信息'),
});